import { JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../base-types";
import Link from "../link";
import Resource from "./resource";
@JsonObject()
export default class SettingResource extends Resource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("value")
    value: string;

    @JsonProperty("schema")
    schema: Nullable<Record<string, unknown>>;

    @JsonProperty("category")
    category: Link;
}

export { SettingResource };
